import React from 'react';
import * as messages from '@radnuc/messages';
import NodeHealth, {SensorHealthData ,NodeHealthData, SensorComponentHealthOrder,IsPERM_M_CBRN, HasCloudUI, GetCloudUIUrl} from '../NodeHealth';
import './NodeHealthDisplay.css'
import open_in_new_logo from './img/4964026_add_in_new_open_plus_icon_white.png';
import location_circle_white_logo from './img/ic_my_location_48px_white.png'
import { CloudUiDisplayInterface, CloudUiDisplayParam } from './CloudUiDisplay';
//import { Textfit } from 'react-textfit';

interface HealthStatusDisplayInterface {open: ()=> void, close: ()=> void}
//export interface HealthSummaryDisplayProps {healthData: HealthData[], isPrimary?: boolean}
type NodeSummary = {good:number, attn:number, fail:number, offline:number, startup:number}

const API_ROOT = window.app && window.app.env.API_URL;

export interface NodeHealthSummaryDisplayProps {healthData: Map<string,NodeHealthData>, cloudUiDisplayInterface?:CloudUiDisplayInterface}
export interface NodeHealthSummaryDisplayState {menuOpen: boolean, time: Date}
export class NodeHealthStatusSummaryDisplay extends React.Component<NodeHealthSummaryDisplayProps,NodeHealthSummaryDisplayState> {
    heartbeatInterval:number = 10000*1.5; //msec
    heartbeatTimer:NodeJS.Timeout | null = null;
    constructor(props: NodeHealthSummaryDisplayProps) {
        super(props)
        this.handleHealthSummaryButtonClick = this.handleHealthSummaryButtonClick.bind(this);
        this.state = {
            menuOpen: false,
            time: new Date()
        }
    }
    componentWillUnmount(){
        if(this.heartbeatTimer !== null){
            clearTimeout(this.heartbeatTimer);
        }
    }
    handleHealthSummaryButtonClick(flag: boolean){
        this.setState(() => ({
            menuOpen: flag
        }));
    }

    getSummaryHealthState() : NodeSummary {
        let result = {good:0,attn:0,fail:0,offline:0, startup:0};
        //let waiting_flag = false;
        //let timeout_flag = false;
        this.props.healthData.forEach((node:NodeHealthData,key:string) => {
            if(key !== 'NETWORK'){
                const this_node_state = node.getState();
                if(node.time.getTime()+this.heartbeatInterval >= new Date().getTime()){
                //if(node.lastMessage.getTime()+this.heartbeatInterval >= new Date().getTime()){
                    if(this_node_state === messages.Core.BasicHealthState.STARTUP){
                        //waiting_flag = true;
                        //Waiting
                        result.startup = result.startup + 1
                    } else if(this_node_state === messages.Core.BasicHealthState.GOOD){
                        result.good = result.good + 1
                    } else if(this_node_state === messages.Core.BasicHealthState.DEGRADED){
                        result.attn = result.attn + 1
                    } else if(this_node_state === messages.Core.BasicHealthState.BAD){
                        result.fail = result.fail + 1
                    } else if(this_node_state === 4){ //OFFLINE
                        result.offline = result.offline + 1
                    }
                } else {
                    //result.offline = result.offline + 1
                    //timeout_flag = true;
                }
            }
        })
        /*
        if(waiting_flag){
            result = messages.Core.BasicHealthState.STARTUP;
        }
        if(timeout_flag){
            result = 4;
        }
        */

        return result;
    }

    getSummaryString(summaryHealthState: number){
        if(summaryHealthState === messages.Core.BasicHealthState.GOOD){
            return 'OK';
        } else if (summaryHealthState === messages.Core.BasicHealthState.DEGRADED){
            return 'ATTN';
        } else if (summaryHealthState === messages.Core.BasicHealthState.BAD){
            return 'FAIL';
        } else if (summaryHealthState === 4) {
            return 'OFFLINE';
        } else if (summaryHealthState === 0) {
            return 'WAIT';
        } else {
            return 'WAIT';
        }
    }

    getSummaryClass(summaryHealthState: number){
        if(summaryHealthState === messages.Core.BasicHealthState.GOOD){
            return 'good';
        } else if (summaryHealthState === messages.Core.BasicHealthState.DEGRADED){
            return 'degraded';
        } else if (summaryHealthState === messages.Core.BasicHealthState.BAD){
            return 'bad';
        } else if (summaryHealthState === 4) {
            return 'fail';
        } else if (summaryHealthState === 0) {
            return '';
        } else {
            return '';
        }
    }

    startTimer(){
        if(this.heartbeatTimer !== null){
            clearTimeout(this.heartbeatTimer);
        }
        this.heartbeatTimer = setTimeout(() =>{
            //Change in state triggers redraw
            this.setState({time: new Date()});
        },this.heartbeatInterval)
    }

    render() {
        this.startTimer();
        const healthStatusDisplayInterface = {
            open: ()=>this.setState({menuOpen: true}),
            close: ()=>this.setState({menuOpen: false})
        }
        const summaryHealthState = this.getSummaryHealthState();
        //const healthStateSummaryString = this.getSummaryString(summaryHealthState);
        //const healthStateClass = this.getSummaryClass(summaryHealthState);

        let nodeSummaries:JSX.Element[] = [];
        if(summaryHealthState.good !== null && summaryHealthState.good > 0){
            const thisSummary = <NodeSummaryDisplay key={1} numNodes={summaryHealthState.good} healthStatusClass={'good'}/>
            nodeSummaries.push(thisSummary);
        }
        if(summaryHealthState.attn !== null && summaryHealthState.attn > 0){
            const thisSummary = <NodeSummaryDisplay key={2} numNodes={summaryHealthState.attn} healthStatusClass={'degraded'}/>
            nodeSummaries.push(thisSummary);
        }
        if(summaryHealthState.fail !== null && summaryHealthState.fail > 0){
            const thisSummary = <NodeSummaryDisplay key={3} numNodes={summaryHealthState.fail} healthStatusClass={'bad'}/>
            nodeSummaries.push(thisSummary);
        }
        if(summaryHealthState.offline !== null && summaryHealthState.offline > 0){
            const thisSummary = <NodeSummaryDisplay key={4} numNodes={summaryHealthState.offline} healthStatusClass={'offline'}/>
            nodeSummaries.push(thisSummary);
        }
        if(summaryHealthState.startup !== null && summaryHealthState.startup > 0){
            const thisSummary = <NodeSummaryDisplay key={5} numNodes={summaryHealthState.startup} healthStatusClass={''}/>
            nodeSummaries.push(thisSummary);
        }

        return (
            <>
            <div id="system-status" className={"metric-container "} style={{cursor:'pointer'}} onClick={()=>{this.handleHealthSummaryButtonClick(true)}}>
                <label id="system-status" className={"metric-title"}>System Status</label>
                <div style={{display:'flex', flexDirection: 'row', justifyContent:'space-evenly',marginTop:'5px'}}>
                    {nodeSummaries}
                </div>
            </div>
            <HealthStatusDisplay menuOpen={this.state.menuOpen} healthData={this.props.healthData} healthStatusDisplayInterface={healthStatusDisplayInterface} cloudUiDisplayInterface={this.props.cloudUiDisplayInterface}/>
            </>
        )
    }
}
//export enum NodeHealthStates {STARTUP,GOOD,ATTN,FAIL,OFFLINE}
interface NodeSummaryDisplayProps {numNodes: number, healthStatusClass:string}
export class NodeSummaryDisplay extends React.Component<NodeSummaryDisplayProps> {

    render() {
        let tooltipString = '';
        if(this.props.healthStatusClass==='good'){
            tooltipString = 'Good'
        } else if (this.props.healthStatusClass==='degraded'){
            tooltipString = 'Attention'
        } else if (this.props.healthStatusClass==='bad'){
            tooltipString = 'Fail'
        } else if (this.props.healthStatusClass==='offline'){
            tooltipString = 'Offline'
        } else {
            tooltipString = 'Waiting for Health Status'
        }

        return(
            <div title={tooltipString} className={"status-metric-indicator "+ this.props.healthStatusClass} style={{ height:22,width:22,borderRadius:7}}>
                <div style={{ display:'flex',justifyContent:'center'}}>
                    <label id="node-summary-status" className={"metric "+ this.props.healthStatusClass}>{this.props.numNodes}</label>
                </div>
            </div>

        )
    }
}


export interface SensorHealthDisplayProps {title: string, healthData: SensorHealthData | undefined}
export interface SensorHealthDisplayState {expanded: boolean, offline: boolean, time: Date}
export class SensorHealthDisplay extends React.Component<SensorHealthDisplayProps,SensorHealthDisplayState> {
    panel_element: React.RefObject<HTMLDivElement>;
    accordion_element: React.RefObject<HTMLButtonElement>;
    heartbeatInterval:number = 10000*1.2; //msec
    ui_message: string = "Connecting...";
    disk_status_message: string | undefined = "N/A";
    heartbeatTimer:NodeJS.Timeout | null = null;

    constructor(props: SensorHealthDisplayProps) {
        super(props)

        this.state ={
            expanded: false,
            offline: false,
            time: new Date()
        }

        this.panel_element = React.createRef<HTMLDivElement>();
        this.accordion_element = React.createRef<HTMLButtonElement>();
        this.handleAccordionClick = this.handleAccordionClick.bind(this);
    }

    componentDidMount(){
        this.init();
    }
    componentWillUnmount(){
        if(this.heartbeatTimer !== null){
            clearTimeout(this.heartbeatTimer);
        }
    }
    handleAccordionClick(){
        if(this.accordion_element.current !== null){
            this.accordion_element.current.classList.toggle("active");
        }
        if(this.panel_element.current !== null){
            let panel = this.panel_element.current;
            panel.classList.toggle("active");
            if(panel !== null){
                if (panel.style.maxHeight) {
                    panel.style.maxHeight = "";
                } else {
                    panel.style.maxHeight = panel.scrollHeight + "px";
                }
            }
        }
    }

    init(){
        this.ui_message = 'Connecting...';
        this.disk_status_message = 'N/A';
    }

    healthStateToClass(healthState:number){
        switch(healthState){
            //case messages.Core.BasicHealthState.STARTUP:
            //    return 'starting'
            case messages.Core.BasicHealthState.GOOD:
                return 'good'
            case messages.Core.BasicHealthState.DEGRADED:
                return 'degraded'
            case messages.Core.BasicHealthState.BAD:
                return 'bad'
            case 4:
                return 'offline'
            default:
                return ''
        }
    }

    startTimer(){
        if(this.heartbeatTimer !== null){
            clearTimeout(this.heartbeatTimer);
        }
        this.heartbeatTimer = setTimeout(() =>{
            //Change in state triggers redraw
            this.setState({time: new Date()});
        },this.heartbeatInterval)
    }

    render() {
        this.startTimer();
        const thisHealthData = this.props.healthData;
        let healthStatusClass;
        let statusString;
        if(thisHealthData === undefined){
            this.ui_message = "OFFLINE";
            healthStatusClass =  "offline";
            statusString = this.ui_message;
        } else {
            const time_now = new Date().getTime();
            if(thisHealthData.time.getTime()+this.heartbeatInterval >=  time_now){
            //if(thisHealthData.lastMessage.getTime()+this.heartbeatInterval >=  time_now){
                //Not Timeout
                this.ui_message = thisHealthData.status;
                if (thisHealthData.state === 1 && this.ui_message === null){
                    this.ui_message = 'OK';
                }
                healthStatusClass =  this.healthStateToClass(thisHealthData.state);

            } else {
                //console.log(thisHealthData.device+' '+thisHealthData.model+' Stale Health State '+thisHealthData.lastMessageTime);
                this.ui_message = "Stale Health State";
                healthStatusClass =  "";
            }
            statusString = this.ui_message;
            if(!thisHealthData.inSummary){
                statusString = "("+statusString+")";
            }

            let statusMetricContainerHeight:string;
            if(this.state.expanded){
                statusMetricContainerHeight= "100%";
            } else {
                statusMetricContainerHeight= "1.2em";
            }
        }
        let sensorHealthDisplay;
        if(thisHealthData?.hideInHealthDisplay){
            sensorHealthDisplay =
                        <>
                        </>
        } else {
            sensorHealthDisplay =
                        <>
                        <button className="accordion" onClick={this.handleAccordionClick} ref={this.accordion_element}>
                    		<div className="status-metric-container"  style={{justifyContent:'flex-start'}}>
                                <label className="status-metric-big">
                                    <div className={"status-metric-indicator "+healthStatusClass}></div>
                                </label>
                                <label className="status-metric-title-big" style={{fontSize:'1.0em'}}>
                                            {this.props.title}
                                </label>
                    		</div>
                    	</button>
                        <div className="panel" ref={this.panel_element}>
                            <div className="status-metric-container">
                                <label className="status-metric-title">Status</label>
                                <label className={"status-metric "+ healthStatusClass}>{statusString}</label>
                            </div>

                        </div>
                        </>
        }


        return (
            <>
            {sensorHealthDisplay}
            </>
        )
    }
}

//FLAT ONE LEVEL NODE HEALTH
export interface NodeHealthDisplayProps {title: string, healthData: NodeHealthData | undefined, targetURL?:string, cloudUiDisplayInterface?:CloudUiDisplayInterface}
export interface NodeHealthDisplayState {expanded: boolean, offline: boolean, time: Date}
export class NodeHealthDisplay extends React.Component<NodeHealthDisplayProps,NodeHealthDisplayState> {
    panel_element: React.RefObject<HTMLDivElement>;
    accordion_element: React.RefObject<HTMLButtonElement>;
    heartbeatInterval:number = 10000*1.2; //msec
    ui_message: string = "Connecting...";
    //disk_status_message: string | undefined = "N/A";
    heartbeatTimer:NodeJS.Timeout | null = null;

    constructor(props: NodeHealthDisplayProps) {
        super(props)

        this.state ={
            expanded: false,
            offline: false,
            time: new Date()
        }

        this.panel_element = React.createRef<HTMLDivElement>();
        this.accordion_element = React.createRef<HTMLButtonElement>();
        this.handleAccordionClick = this.handleAccordionClick.bind(this);
        this.handleOpenCloudUIUrl = this.handleOpenCloudUIUrl.bind(this);
        this.handleOpenInAnotherWindow = this.handleOpenInAnotherWindow.bind(this);
        this.handleTrackThisSensor = this.handleTrackThisSensor.bind(this);
    }

    componentDidMount(){
        this.init();
    }

    componentWillUnmount(){
        if(this.heartbeatTimer !== null){
            clearTimeout(this.heartbeatTimer);
        }
    }

    handleAccordionClick(){
        if(this.accordion_element.current !== null){
            this.accordion_element.current.classList.toggle("active");
        }
        if(this.panel_element.current !== null){
            let panel = this.panel_element.current;
            panel.classList.toggle("active");
            if(panel !== null){
                if (panel.style.maxHeight) {
                    panel.style.maxHeight = "";
                } else {
                    //panel.style.maxHeight = panel.scrollHeight + "px";
                    panel.style.maxHeight = "max-content"
                }
            }
        }
    }

    init(){
        this.ui_message = 'Connecting...';
        //this.disk_status_message = 'N/A';
    }

    healthStateToClass(healthState:number){
        switch(healthState){
            case messages.Core.BasicHealthState.STARTUP:
                return ''
            case messages.Core.BasicHealthState.GOOD:
                return 'good'
            case messages.Core.BasicHealthState.DEGRADED:
                return 'degraded'
            case messages.Core.BasicHealthState.BAD:
                return 'bad'
            case 4:
                return 'offline'
            default:
                return ''
        }
    }

    startTimer(){
        if(this.heartbeatTimer !== null){
            clearTimeout(this.heartbeatTimer);
        }
        this.heartbeatTimer = setTimeout(() =>{
            //Change in state triggers redraw
            this.setState({time: new Date()});
        },this.heartbeatInterval)
    }

    handleOpenCloudUIUrl(event: React.MouseEvent<HTMLElement>) {
        event.stopPropagation();

        this.handleOpenInAnotherWindow();
        /*
        if(this.props.cloudUiDisplayInterface){
            if(this.props.targetURL){
            const thisParam:CloudUiDisplayParam = {isShowing:true,device:this.props.title, url:this.props.targetURL}
                this.props.cloudUiDisplayInterface.open(thisParam);
            }
        }
        */
    }

    handleOpenInAnotherWindow(){
        //SPAWN TO NEW TAB?
        const strWindowFeatures = "location=yes,height=570,width=520,scrollbars=yes,status=yes";
        const URL = this.props.targetURL+'\?=suppressLoginScreen';
        //let newWindow = window.open(URL, "_blank");//, strWindowFeatures);
        const width = window.innerWidth;
        const height = window.innerHeight;

        const newWindow = window.open(
          URL,
          "_blank",
          `width=${width},height=${height}`
        );
        //if(newWindow !== null){
        const sendMessageFunc = () => {
                const thisCloudUiInterface = this.props.cloudUiDisplayInterface;
                const session_user = window.sessionStorage.getItem('cred1');
                const session_pass = window.sessionStorage.getItem('cred2');
                const session_token = window.sessionStorage.getItem('token');
                //const invUuid = window.sessionStorage.getItem('invUuid');
                const credobj = {cred1:session_user,cred2:session_pass,cred3:(Date.now()+5000).toString(),token:session_token,invUuid:undefined};
                //console.log(credobj)
                const jsoncredobj = JSON.stringify(credobj);

                const sendMessage = () => {
                    if(newWindow !== null){
                        if(this.props.targetURL){
                            newWindow.postMessage(jsoncredobj, this.props.targetURL);//"*");
                        }
                    }
                };
                sendMessage();
        }

        setTimeout(()=>{
            sendMessageFunc();
        },3000);
    }

    handleTrackThisSensor(event: React.MouseEvent<HTMLElement>) {
        event.stopPropagation();
        if(this.props.cloudUiDisplayInterface){
            if(this.props.cloudUiDisplayInterface?.setTrackedDevice){
                this.props.cloudUiDisplayInterface?.setTrackedDevice(this.props.healthData?.device)
                setTimeout(()=>{
                    this.props.cloudUiDisplayInterface!.setTrackedDevice!(undefined)
                },1000)
            }
        }
    }

    render() {
        this.startTimer();
        const thisHealthData = this.props.healthData;
        let healthStatusClass;
        let statusString;
        if(thisHealthData === undefined){
            this.ui_message = "OFFLINE";
            healthStatusClass =  "offline";
            statusString = this.ui_message;
        } else {
            if(thisHealthData.time.getTime()+this.heartbeatInterval >=  new Date().getTime()){
            //if(thisHealthData.lastMessage.getTime()+this.heartbeatInterval >= new Date().getTime()){
                //Not Timeout
                //this.ui_message = thisHealthData.status;
                healthStatusClass =  this.healthStateToClass(thisHealthData.state);

            } else {
                this.ui_message = "Stale Health Message";
                healthStatusClass =  "";
            }
            statusString = this.ui_message;
            if(!thisHealthData.inSummary){
                statusString = "("+statusString+")";
            }

            let statusMetricContainerHeight:string;
            if(this.state.expanded){
                statusMetricContainerHeight= "100%";
            } else {
                statusMetricContainerHeight= "1.2em";
            }
        }
        let sensorHealths:JSX.Element[] = [];
        if(this.props.healthData !== undefined){

            //FLAT ONE LEVEL HEALTH
            const sortorder = SensorComponentHealthOrder;
            let sortedSensorHealth = Object.values(this.props.healthData.sensors).sort(function(a,b){
                //console.log(a.model+sortorder.indexOf(a.model)+" "+b.model+" "+sortorder.indexOf(b.model))
                return sortorder.indexOf(a.model) - sortorder.indexOf(b.model);
            })
            sortedSensorHealth.forEach((sensorHealthData,idx) => {
                const make_model_serial = sensorHealthData.make+' '+sensorHealthData.model+' '+sensorHealthData.serial;
                //const make_model = sensorHealthData.make+' '+sensorHealthData.model;
                const make_model = sensorHealthData.model;
                const thisSensorDisplay =
                     <div key={idx} style={{marginLeft:'17px'}}>
                        <SensorHealthDisplay key={idx} title={make_model} healthData={sensorHealthData} />
                     </div>
                sensorHealths.push(thisSensorDisplay)
            });

        }
        let openInNewButton;
        if(this.props.targetURL !== undefined) {
            openInNewButton=
                <div className={"round-button "}
                    style={{marginRight: '3px', padding: '5px', width:'20px', height:'20px', backgroundColor:'#00000000'}} onClick={()=>{console.log('click open in new ')}}>
                    <div style={{marginRight:'0px',padding:'0px'}}>
                        <img style={{background:'none',height:'30px',width:'30px'}} className="dosemap-type-img" src={open_in_new_logo} onClick={this.handleOpenCloudUIUrl}/>
                    </div>
                </div>
        }
        let trackThisSensorButton;
        if(this.props.healthData?.latitude && this.props.healthData?.longitude){
            trackThisSensorButton=
                <div className={"round-button "}
                    style={{marginRight: '10px', padding: '5px', width:'20px', height:'20px', backgroundColor:'#00000000'}}>
                    <div style={{marginRight:'0px',padding:'0px'}}>
                        <img style={{background:'none',height:'26px',width:'26px'}} className="dosemap-type-img" src={location_circle_white_logo} onClick={this.handleTrackThisSensor}/>
                    </div>
                </div>
        } else {
            trackThisSensorButton=
                <div className={"round-button "}
                    style={{marginRight: '10px', padding: '5px', width:'20px', height:'20px', backgroundColor:'#00000000'}}>
                    <div style={{marginRight:'0px',padding:'0px'}}>
                        <img style={{background:'none',height:'26px',width:'26px', opacity:0.3}} className="dosemap-type-img" src={location_circle_white_logo} onClick={(event)=>{event.stopPropagation()}}/>
                    </div>
                </div>
        }

        return (
            <>
            <button className="accordion" onClick={this.handleAccordionClick} ref={this.accordion_element}>
        		<div className="status-metric-container">
                    <label className="status-metric-title-big">
                        <div style={{width:'150px',wordWrap:'break-word',wordBreak:'break-word',whiteSpace:'normal'}}>
                            {this.props.title}
                        </div>
                    </label>
                    <label className="status-metric-big" style={{paddingRight:'22px',paddingLeft:'5px'}}>
                        <div style={{display:'flex', flexDirection:'row',alignItems:'center'}}>
                            {openInNewButton}
                            {trackThisSensorButton}
                            <div className={"status-metric-indicator "+healthStatusClass}></div>
                        </div>
                    </label>
        		</div>
        	</button>
            <div className="panel" ref={this.panel_element}>
                {sensorHealths}
            </div>
            </>
        )
    }
}

//CBRN NODE HEALTH
export class CBRNNodeHealthDisplay extends React.Component<NodeHealthDisplayProps,NodeHealthDisplayState> {
    panel_element: React.RefObject<HTMLDivElement>;
    accordion_element: React.RefObject<HTMLButtonElement>;
    heartbeatInterval:number = 10000*1.2; //msec
    ui_message: string = "Connecting...";
    //disk_status_message: string | undefined = "N/A";
    heartbeatTimer:NodeJS.Timeout | null = null;

    systemHealthStatusClass="";
    radHealthStatusClass="";
    chemHealthStatusClass="";
    bioHealthStatusClass="";

    constructor(props: NodeHealthDisplayProps) {
        super(props)

        this.state ={
            expanded: false,
            offline: false,
            time: new Date()
        }

        this.panel_element = React.createRef<HTMLDivElement>();
        this.accordion_element = React.createRef<HTMLButtonElement>();
        this.handleAccordionClick = this.handleAccordionClick.bind(this);
        this.handleOpenCloudUIUrl = this.handleOpenCloudUIUrl.bind(this);
        this.handleOpenInAnotherWindow = this.handleOpenInAnotherWindow.bind(this);
        this.handleTrackThisSensor = this.handleTrackThisSensor.bind(this);
    }

    componentDidMount(){
        this.init();
    }

    componentWillUnmount(){
        if(this.heartbeatTimer !== null){
            clearTimeout(this.heartbeatTimer);
        }
    }

    handleAccordionClick(){
        if(this.accordion_element.current !== null){
            this.accordion_element.current.classList.toggle("active");
        }
        if(this.panel_element.current !== null){
            let panel = this.panel_element.current;
            panel.classList.toggle("active");
            if(panel !== null){
                if (panel.style.maxHeight) {
                    panel.style.maxHeight = "";
                } else {
                    //panel.style.maxHeight = panel.scrollHeight + "px";
                    panel.style.maxHeight = "max-content"
                }
            }
        }
    }

    init(){
        this.ui_message = 'Connecting...';
        //this.disk_status_message = 'N/A';
    }

    healthStateToClass(healthState:number){
        switch(healthState){
            case messages.Core.BasicHealthState.STARTUP:
                return ''
            case messages.Core.BasicHealthState.GOOD:
                return 'good'
            case messages.Core.BasicHealthState.DEGRADED:
                return 'degraded'
            case messages.Core.BasicHealthState.BAD:
                return 'bad'
            case 4:
                return 'offline'
            default:
                return ''
        }
    }

    startTimer(){
        if(this.heartbeatTimer !== null){
            clearTimeout(this.heartbeatTimer);
        }
        this.heartbeatTimer = setTimeout(() =>{
            //Change in state triggers redraw
            this.setState({time: new Date()});
        },this.heartbeatInterval)
    }

    getSubsystemSummaryHealthState(subsystemComponents:number[], healthData:NodeHealthData){
        let componentHealthState:number[] = []; //Array();
        const components = healthData.sensors
        const keys = Object.keys(components);
        const thisNodeHealthData = healthData;
        keys.forEach((key)=>{
            let thisComponentData = components[key];
            const component_number = Number.parseInt(key.replace('PSI ','').replace(' '+healthData.device,''));
            //console.log(subsystemComponents)
            if(subsystemComponents.includes(component_number)){
                //console.log(thisComponentData.model)
                const thisHeartbeatInterval = 30000; //.heartbeat * 1.2;

                if(thisComponentData.inSummary){
                    //console.log('update component '+component_number+' '+thisComponentData.state)
                    if(thisComponentData.time.getTime()+thisHeartbeatInterval >= new Date().getTime()){
                        componentHealthState.push(thisComponentData.state);
                    } else {
                        componentHealthState.push(4); //Offline
                    }
                }
            }

        });

        let summaryHealthState = 0;
        if(componentHealthState.includes(1)){
            //Set to OK, class good
            summaryHealthState = messages.Rad.HealthState.GOOD;
        }
        if(componentHealthState.includes(2)){
            //Set to ATTN, class degraded
            summaryHealthState = messages.Rad.HealthState.DEGRADED;
        }
        if(componentHealthState.includes(3)){
            //Set to FAIL, class bad
            summaryHealthState = messages.Rad.HealthState.BAD;
        }
        if(componentHealthState.includes(4)){
            //Set to FAIL, class bad
            summaryHealthState = messages.Rad.HealthState.BAD;
        }
        const isOffline = (currentValue:number) => (currentValue===-1 || currentValue===4);
        if(componentHealthState.every(isOffline)){
            //Set to OFFLINE, class bad
            summaryHealthState = 4;
        }
        if(componentHealthState.includes(0)){
            //Set to WAIT, class good
            summaryHealthState = 0;
        }

        return (summaryHealthState)

    }

    handleOpenCloudUIUrl(event: React.MouseEvent<HTMLElement>) {
        event.stopPropagation();
        this.handleOpenInAnotherWindow();
        /*
        if(this.props.cloudUiDisplayInterface){
            if(this.props.targetURL){
            const thisParam:CloudUiDisplayParam = {isShowing:true,device:this.props.title, url:this.props.targetURL}
                this.props.cloudUiDisplayInterface.open(thisParam);
            }
        }
        */
    }

    handleOpenInAnotherWindow(){
        //SPAWN TO NEW TAB?
        const strWindowFeatures = "location=yes,height=570,width=520,scrollbars=yes,status=yes";
        const URL = this.props.targetURL+'\?=suppressLoginScreen';
        //let newWindow = window.open(URL, "_blank");//, strWindowFeatures);
        const width = window.innerWidth;
        const height = window.innerHeight;

        const newWindow = window.open(
          URL,
          "_blank",
          `width=${width},height=${height}`
        );
        //if(newWindow !== null){
        const sendMessageFunc = () => {
                const thisCloudUiInterface = this.props.cloudUiDisplayInterface;
                const session_user = window.sessionStorage.getItem('cred1');
                const session_pass = window.sessionStorage.getItem('cred2');
                const session_token = window.sessionStorage.getItem('token');
                //const invUuid = window.sessionStorage.getItem('invUuid');
                const credobj = {cred1:session_user,cred2:session_pass,cred3:(Date.now()+5000).toString(),token:session_token,invUuid:undefined};
                //console.log(credobj)
                const jsoncredobj = JSON.stringify(credobj);

                const sendMessage = () => {
                    if(newWindow !== null){
                        if(this.props.targetURL){
                            newWindow.postMessage(jsoncredobj, this.props.targetURL);//"*");
                        }
                    }
                };
                sendMessage();
        }

        setTimeout(()=>{
            sendMessageFunc();
        },3000);
    }



    handleTrackThisSensor(event: React.MouseEvent<HTMLElement>) {
        event.stopPropagation();
        if(this.props.cloudUiDisplayInterface){
            if(this.props.cloudUiDisplayInterface?.setTrackedDevice){
                this.props.cloudUiDisplayInterface?.setTrackedDevice(this.props.healthData?.device)
                setTimeout(()=>{
                    this.props.cloudUiDisplayInterface!.setTrackedDevice!(undefined)
                },1000)
            }
        }
    }

    render() {
        this.startTimer();
        const thisHealthData = this.props.healthData;
        let healthStatusClass;
        let systemHealthStatusClass;
        let radHealthStatusClass;
        let chemHealthStatusClass;
        let bioHealthStatusClass;

        let statusString;
        if(thisHealthData === undefined){
            this.ui_message = "OFFLINE";
            healthStatusClass =  "offline";
            systemHealthStatusClass =  "offline";
            radHealthStatusClass =  "offline";
            chemHealthStatusClass =  "offline";
            bioHealthStatusClass =  "offline";

            statusString = this.ui_message;
        } else {
            if(thisHealthData.time.getTime()+this.heartbeatInterval >=  new Date().getTime()){
            //if(thisHealthData.lastMessage.getTime()+this.heartbeatInterval >= new Date().getTime()){
                //Not Timeout
                //this.ui_message = thisHealthData.status;
                //healthStatusClass =  this.healthStateToClass(thisHealthData.state);
                systemHealthStatusClass = this.systemHealthStatusClass;
                radHealthStatusClass = this.radHealthStatusClass;
                chemHealthStatusClass = this.chemHealthStatusClass;
                bioHealthStatusClass = this.bioHealthStatusClass;

            } else {
                this.ui_message = "Stale Health Message";
                healthStatusClass =  "";
                systemHealthStatusClass = "";
                radHealthStatusClass = "";
                chemHealthStatusClass = "";
                bioHealthStatusClass = "";
            }
            statusString = this.ui_message;
            if(!thisHealthData.inSummary){
                statusString = "("+statusString+")";
            }

            let statusMetricContainerHeight:string;
            if(this.state.expanded){
                statusMetricContainerHeight= "100%";
            } else {
                statusMetricContainerHeight= "1.2em";
            }
        }
        //systemHealthStatusClass = healthStatusClass;

        let sensorHealths:JSX.Element[] = [];
        if(this.props.healthData !== undefined){

            const thisSensors =  this.props.healthData.sensors;
            const thisMake = 'PSI';
            const thisSerial = this.props.healthData?.device;

            let predetection_components = [messages.Rad.HealthComponent.LOG,
                                           messages.Rad.HealthComponent.GPS,
                                           messages.Rad.HealthComponent.INVESTIGATION]
            predetection_components.forEach(component => {
                const make_model_serial = thisMake+' '+component+' '+thisSerial;
                //const make_model = sensorHealthData.make+' '+sensorHealthData.model;
                const thisSensorHealthData = thisSensors[make_model_serial];
                if(thisSensorHealthData){
                    const thisSensorDisplay =
                         <div key={make_model_serial} style={{marginLeft:'17px'}}>
                            <SensorHealthDisplay key={make_model_serial} title={thisSensorHealthData.model} healthData={thisSensorHealthData} />
                         </div>
                    sensorHealths.push(thisSensorDisplay)
                }
            });
            /*RADNUC SUBSYSTTEM*/
            let radnuc_components = [messages.Rad.HealthComponent.TMU,
                                     messages.Rad.HealthComponent.RAD,
                                     messages.Rad.HealthComponent.PCS,
                                     messages.Rad.HealthComponent.NEUTRON];
            sensorHealths.push(<SubsystemComponentHealthDisplay key={thisMake+thisSerial+'RADNUC'} title={'RAD/NUC'} healthData={this.props.healthData} subsystemComponents={radnuc_components}
                                  callback={(healthState:number)=>{this.radHealthStatusClass = this.healthStateToClass(healthState);}}/>)

            /*CHEM SUBSYSTTEM*/
            let chem_components = [messages.Rad.HealthComponent.CHEM_DATA,
                                   messages.Rad.HealthComponent.CHEM_DETECTION];
            sensorHealths.push(<SubsystemComponentHealthDisplay key={thisMake+thisSerial+'CHEM'}title={'CHEM'} healthData={this.props.healthData} subsystemComponents={chem_components}
                                     callback={(healthState:number)=>{this.chemHealthStatusClass = this.healthStateToClass(healthState);}}/>)

            /*BIO SUBSYSTTEM*/
            let bio_components = [messages.Rad.HealthComponent.BIO_DATA,
                                     messages.Rad.HealthComponent.BIO_DETECTION];


            sensorHealths.push(<SubsystemComponentHealthDisplay key={thisMake+thisSerial+'BIO'} title={'BIO'} healthData={this.props.healthData} subsystemComponents={bio_components}
                                        callback={(healthState:number)=>{this.bioHealthStatusClass = this.healthStateToClass(healthState);}}/>)


            let postdetection_components = [messages.Rad.HealthComponent.CONFIG,
                                            messages.Rad.HealthComponent.SIGMA_EDGE]
            postdetection_components.forEach(component => {
                const make_model_serial = thisMake+' '+component+' '+thisSerial;
                //const make_model = sensorHealthData.make+' '+sensorHealthData.model;
                const thisSensorHealthData = thisSensors[make_model_serial];
                if(thisSensorHealthData){
                    const thisSensorDisplay =
                         <div key={make_model_serial} style={{marginLeft:'17px'}}>
                            <SensorHealthDisplay key={make_model_serial} title={thisSensorHealthData.model} healthData={thisSensorHealthData} />
                         </div>
                    sensorHealths.push(thisSensorDisplay)
                }
            });

            //This is to calculate the system health but doesn't get displayed
            let system_components = predetection_components.concat(postdetection_components);
            this.systemHealthStatusClass =  this.healthStateToClass(this.getSubsystemSummaryHealthState(system_components,this.props.healthData));

        }

        let openInNewButton;
        if(this.props.targetURL !== undefined) {
            openInNewButton=
                <div className={"round-button "}
                    style={{marginRight: '3px', padding: '5px', width:'20px', height:'20px', backgroundColor:'#00000000'}} onClick={()=>{console.log('click open in new ')}}>
                    <div style={{marginRight:'0px',padding:'0px'}}>
                        <img style={{background:'none',height:'30px',width:'30px'}} className="dosemap-type-img" src={open_in_new_logo} onClick={this.handleOpenCloudUIUrl}/>
                    </div>
                </div>
        }
        let trackThisSensorButton;
        if(this.props.healthData?.latitude && this.props.healthData?.longitude){
            trackThisSensorButton=
                <div className={"round-button "}
                    style={{marginRight: '10px', padding: '5px', width:'20px', height:'20px', backgroundColor:'#00000000'}}>
                    <div style={{marginRight:'0px',padding:'0px'}}>
                        <img style={{background:'none',height:'26px',width:'26px'}} className="dosemap-type-img" src={location_circle_white_logo} onClick={this.handleTrackThisSensor}/>
                    </div>
                </div>
        } else {
            trackThisSensorButton=
                <div className={"round-button "}
                    style={{marginRight: '10px', padding: '5px', width:'20px', height:'20px', backgroundColor:'#00000000'}}>
                    <div style={{marginRight:'0px',padding:'0px'}}>
                        <img style={{background:'none',height:'26px',width:'26px', opacity:0.3}} className="dosemap-type-img" src={location_circle_white_logo} onClick={(event)=>{event.stopPropagation()}}/>
                    </div>
                </div>
        }
        const debugtext = 'panynj-pm-cbrn-7-ctu-jfk-f350-53126'
        return (
            <>
            <button className="accordion" onClick={this.handleAccordionClick} ref={this.accordion_element}>
        		<div className="status-metric-container">
                    <label className="status-metric-title-big">
                        <div style={{width:'150px',wordWrap:'break-word',wordBreak:'break-word',whiteSpace:'normal'}}>
                                {this.props.title}
                        </div>
                    </label>

                    <label className="status-metric-big" style={{paddingRight:'10px',paddingLeft:'5px'}}>
                        <div style={{display:'flex', flexDirection:'row',alignItems:'center'}}>
                            {openInNewButton}
                            {trackThisSensorButton}
                            <div className={"status-metric-indicator "+systemHealthStatusClass} style={{height:'20px',width:'20px',borderRadius:'12px',marginRight:'4px'}}>
                            </div>
                            <div style={{display:'flex',flexDirection:'column',justifyContent:'center'}}>
                                    <div className={"tiny-status-metric-indicator "+radHealthStatusClass}>R</div>
                                    <div className={"tiny-status-metric-indicator "+chemHealthStatusClass}>C</div>
                                    <div className={"tiny-status-metric-indicator "+bioHealthStatusClass}>B</div>
                            </div>
                        </div>
                    </label>
        		</div>
        	</button>
            <div className="panel" ref={this.panel_element}>
                {sensorHealths}
            </div>
            </>
        )
    }
}
export interface SubsystemComponentHealthDisplayProps {title: string, healthData:NodeHealthData, subsystemComponents:number[], callback:(healthState:number)=>void}
export class SubsystemComponentHealthDisplay extends React.Component<SubsystemComponentHealthDisplayProps> {

    constructor(props: SubsystemComponentHealthDisplayProps) {
        super(props)
    }

    render(){
        const thisSensors =  this.props.healthData.sensors;
        const thisMake = 'PSI';
        const thisSerial = this.props.healthData?.device;
        let displayComponents:JSX.Element[] = [];
        let sensorHealths = [];

        this.props.subsystemComponents.forEach(component => {

            const make_model_serial = thisMake+' '+component+' '+thisSerial;
            const thisSensorHealthData = thisSensors[make_model_serial];
            if(thisSensorHealthData){
                if(thisSensorHealthData !== undefined){
                    displayComponents.push(
                        <div key={make_model_serial+"div"} style={{marginLeft:'17px'}}>
                            <SensorHealthDisplay key={make_model_serial} title={thisSensorHealthData.model} healthData={thisSensorHealthData}/>
                        </div>
                    );
                }
            }
        });
        if(displayComponents.length === 0){
            displayComponents.push(
                <div key={thisMake+thisSerial+"offlinemessage"}style={{marginLeft:'17px',color:'darkgray'}}>
                    NO COMPONENT REPORTING
                </div>
            )
        }
        sensorHealths.push(
            <div key={'PSI_'+this.props.healthData?.device+'_'+this.props.title+'_div'} style={{marginLeft:'17px'}}>
                <HealthSubsystemDisplay key={'PSI_'+this.props.healthData?.device+'_'+this.props.title} title={this.props.title} healthData={this.props.healthData}
                    subsystemComponent={this.props.subsystemComponents} subsystemDisplayComponent={displayComponents}
                    callback={this.props.callback}/>
            </div>
        )
        return(sensorHealths);
    }


}



export interface HealthStatusDisplayProps {menuOpen: boolean, healthData: Map<string,NodeHealthData>, healthStatusDisplayInterface:HealthStatusDisplayInterface, cloudUiDisplayInterface?:CloudUiDisplayInterface}
export class HealthStatusDisplay extends React.Component<HealthStatusDisplayProps> {
    constructor(props: HealthStatusDisplayProps) {
        super(props)
        this.handleHealthCloseButtonClick = this.handleHealthCloseButtonClick.bind(this);
    }

    handleHealthCloseButtonClick(){
        this.props.healthStatusDisplayInterface.close();
    }

    renameDeviceName = (deviceName:string)=>{
        if(API_ROOT.DeviceNameRemap){
            const nameMap = new Map<string, string>(
                API_ROOT.DeviceNameRemap.map((item:{DeviceName:string,DeviceDisplayName:string}) => [item.DeviceName, item.DeviceDisplayName])
            );
            return nameMap.get(deviceName) ?? deviceName;
        } else {
            return deviceName;
        }
    }

    render() {
        let sidenavClassName = "sidenav";
        if(this.props.menuOpen){
            sidenavClassName += " open"
        }

        let nodeHealths:JSX.Element[] = [];
        const sortedNodeHealths = new Map(Array.from(this.props.healthData).sort().sort((a, b) => {
            return String(a[0]).localeCompare(b[0]);
        })
        )

        sortedNodeHealths.forEach((nodeHealthData,idx) => {
            //if(nodeHealthData.time.getTime() + 10000 > Date.now()){
            if(nodeHealthData.device !== 'NETWORK'){

                //console.log('Renamed DeviceName: '+this.renameDeviceName(nodeHealthData.device));

                if(HasCloudUI(nodeHealthData.device)){
                    if(IsPERM_M_CBRN(nodeHealthData.device)){
                        nodeHealths.push(<CBRNNodeHealthDisplay key={idx} title={this.renameDeviceName(nodeHealthData.device)} healthData={nodeHealthData} targetURL={GetCloudUIUrl(nodeHealthData.device)} cloudUiDisplayInterface={this.props.cloudUiDisplayInterface}/>)
                    } else {
                        nodeHealths.push(<NodeHealthDisplay key={idx} title={this.renameDeviceName(nodeHealthData.device)} healthData={nodeHealthData} targetURL={GetCloudUIUrl(nodeHealthData.device)} cloudUiDisplayInterface={this.props.cloudUiDisplayInterface}/>)
                    }
                } else {
                    if(IsPERM_M_CBRN(nodeHealthData.device)){
                        nodeHealths.push(<CBRNNodeHealthDisplay key={idx} title={this.renameDeviceName(nodeHealthData.device)} healthData={nodeHealthData} cloudUiDisplayInterface={this.props.cloudUiDisplayInterface}/>)
                    } else {
                        nodeHealths.push(<NodeHealthDisplay key={idx} title={this.renameDeviceName(nodeHealthData.device)} healthData={nodeHealthData} cloudUiDisplayInterface={this.props.cloudUiDisplayInterface}/>)
                    }
                    //nodeHealths.push(<NodeHealthDisplay key={idx} title={nodeHealthData.device} healthData={nodeHealthData} />)
                }

            }
            //}
        });

        const statusContainer =
            <div id="system-status-container" className={sidenavClassName} style={{cursor: 'pointer'}}>
                <div className="sidenav-menu" style={{display:'flex', flexDirection: 'row', alignItems:'center', justifyContent:'space-between'}}>
                    <div className="system-status status-metric-container">
                        <label className="status-metric-title-big">Node Status</label>
                    </div>
                    <div className="closebtn" style={{cursor:'pointer'}} onClick={this.handleHealthCloseButtonClick}>&times;</div>
                </div>
                <div className="sidenav-container">
                    {nodeHealths}
                    <div style={{height:60}}></div>
                </div>
            </div>

        return(
            <>
            {statusContainer}
            </>
        )
    }
}

//CBRN Subcomponent display

export interface HealthSubsystemDisplayProps {title: string,
    //healthData: Map<number,NodeHealthData>,
    healthData: NodeHealthData,
    subsystemComponent: messages.Rad.HealthComponent[], subsystemDisplayComponent:JSX.Element[],
    callback:(healthState:number)=>void,
    heartbeatInterval?:number}
export interface HealthSubsytemDisplayState {expanded: boolean, offline: boolean, time: Date}
export class HealthSubsystemDisplay extends React.Component<HealthSubsystemDisplayProps,HealthSubsytemDisplayState> {
    panel_element: React.RefObject<HTMLDivElement>;
    accordion_element: React.RefObject<HTMLButtonElement>;
    heartbeatInterval:number = 10000*1.2; //msec
    heartbeatTimer:NodeJS.Timeout | null = null;
    resizeObserver: ResizeObserver | undefined;

    constructor(props: HealthSubsystemDisplayProps) {
        super(props)

        this.state ={
            expanded: false,
            offline: false,
            time: new Date()
        }

        this.panel_element = React.createRef<HTMLDivElement>();
        this.accordion_element = React.createRef<HTMLButtonElement>();
        this.handleAccordionClick = this.handleAccordionClick.bind(this);

        if(this.props.heartbeatInterval !== undefined){
            this.heartbeatInterval = this.props.heartbeatInterval;
        }
    }

    componentDidMount(){
        this.init();
    }

    componentWillUnmount(){
        if(this.heartbeatTimer !== null){
            clearTimeout(this.heartbeatTimer);
        }
    }

    handleAccordionClick(){
        if(this.accordion_element.current !== null){
            this.accordion_element.current.classList.toggle("active");
        }
        if(this.panel_element.current !== null){
            let panel = this.panel_element.current;
            panel.classList.toggle("active");
            if(panel !== null){
                if (panel.style.maxHeight) {
                    panel.style.maxHeight = "";
                    if(this.resizeObserver){
                        this.resizeObserver.disconnect();
                    }
                } else {
                    //panel.style.maxHeight = panel.scrollHeight + "px";
                    panel.style.maxHeight= panel.scrollHeight + "px";
                    this.resizeObserver = new ResizeObserver(() => {
                        let panel = this.panel_element.current;
                        if(panel !== null){
                            panel.style.maxHeight = panel.scrollHeight + "px";
                        }
                    });
                    for (let i = 0; i < panel.children.length; i++) {
                        this.resizeObserver.observe(panel.children[i]);
                    }

                }
            }
        }
    }

    init(){
    }

    getSubsystemSummaryHealthState(){
        let componentHealthState:number[] = []; //Array();
        const components = this.props.healthData.sensors
        const keys = Object.keys(components);
        const thisNodeHealthData = this.props.healthData;
        keys.forEach((key)=>{
            let thisComponentData = components[key];
            const component_number = Number.parseInt(key.replace('PSI ','').replace(' '+this.props.healthData.device,''));
            //console.log(this.props.subsystemComponent)
            if(this.props.subsystemComponent.includes(component_number)){
                const thisHeartbeatInterval = 30000; //.heartbeat * 1.2;
                if(thisComponentData.inSummary){
                    //console.log('update component '+component_number+' '+thisComponentData.state)
                    if(thisComponentData.time.getTime()+thisHeartbeatInterval >= new Date().getTime()){
                        componentHealthState.push(thisComponentData.state);
                    } else {
                        componentHealthState.push(4); //Offline
                    }
                }
            }

        });

        let summaryHealthState = 0;
        if(componentHealthState.includes(1)){
            //Set to OK, class good
            summaryHealthState = messages.Rad.HealthState.GOOD;
        }
        if(componentHealthState.includes(2)){
            //Set to ATTN, class degraded
            summaryHealthState = messages.Rad.HealthState.DEGRADED;
        }
        if(componentHealthState.includes(3)){
            //Set to FAIL, class bad
            summaryHealthState = messages.Rad.HealthState.BAD;
        }
        if(componentHealthState.includes(4)){
            //Set to FAIL, class bad
            summaryHealthState = messages.Rad.HealthState.BAD;
        }
        const isOffline = (currentValue:number) => (currentValue===-1 || currentValue===4);
        if(componentHealthState.every(isOffline)){
            //Set to OFFLINE, class bad
            summaryHealthState = 4;
        }
        if(componentHealthState.includes(0)){
            //Set to WAIT, class good
            summaryHealthState = 0;
        }

        this.props.callback(summaryHealthState);

        return (summaryHealthState)

    }


    healthStateToClass(healthState:number){
        switch(healthState){
            case messages.Rad.HealthState.GOOD:
                return 'good'
            case messages.Rad.HealthState.DEGRADED:
                return 'degraded'
            case messages.Rad.HealthState.BAD:
                return 'bad'
            case 4:
                return 'offline'
            default:
                return ''
        }
    }

    startTimer(){
        if(this.heartbeatTimer !== null){
            clearTimeout(this.heartbeatTimer);
        }
        this.heartbeatTimer = setTimeout(() =>{
            //Change in state triggers redraw
            this.setState({time: new Date()});
        },this.heartbeatInterval)
    }

    render() {
        this.startTimer();
        const subsystemHealthStatus = this.getSubsystemSummaryHealthState();
        let subsystemHealthStatusClass = this.healthStateToClass(subsystemHealthStatus);

        let statusMetricContainerHeight:string;
        if(this.state.expanded){
            statusMetricContainerHeight= "100%";
        } else {
            statusMetricContainerHeight= "1.2em";
        }

        return (
            <>
            <button className="accordion" onClick={this.handleAccordionClick} ref={this.accordion_element}>
        		<div className="status-metric-container">
                    <label className="status-metric-big">
                        <div className={"status-metric-indicator "+subsystemHealthStatusClass}></div>
                    </label>
                    <label className="status-metric-title-big">
                        <div style={{width: '230px',height:'29px',lineHeight:'29px'}}>
                                {this.props.title}
                        </div>
                    </label>
        		</div>
        	</button>
            <div className="panel" ref={this.panel_element}>
                {this.props.subsystemDisplayComponent}
            </div>
            </>
        )
    }
}
